import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DraggableDesign } from './DraggableDesign';
interface Design {
  id: string;
  image: string;
  x: number;
  y: number;
  scale: number;
  zIndex: number;
}
interface ProductDisplayProps {
  imageUrl: string;
  productName: string;
  colorName: string;
  currentView: 'front' | 'back';
  designs: Design[];
  selectedDesignId: string | null;
  onDesignSelect: (id: string) => void;
  onDesignPositionChange: (designId: string, x: number, y: number) => void;
}
export function ProductDisplay({
  imageUrl,
  productName,
  colorName,
  currentView,
  designs,
  selectedDesignId,
  onDesignSelect,
  onDesignPositionChange
}: ProductDisplayProps) {
  const garmentRef = useRef<HTMLImageElement>(null);
  const [garmentBounds, setGarmentBounds] = useState<DOMRect | null>(null);
  useEffect(() => {
    const updateBounds = () => {
      if (garmentRef.current) {
        setGarmentBounds(garmentRef.current.getBoundingClientRect());
      }
    };
    const img = garmentRef.current;
    if (img) {
      if (img.complete) {
        updateBounds();
      } else {
        img.addEventListener('load', updateBounds);
      }
    }
    window.addEventListener('resize', updateBounds);
    return () => {
      if (img) {
        img.removeEventListener('load', updateBounds);
      }
      window.removeEventListener('resize', updateBounds);
    };
  }, [imageUrl]);
  return <div className="flex items-center justify-center h-full" data-id="element-97">
      <AnimatePresence mode="wait" data-id="element-98">
        <motion.div key={`${imageUrl}-${currentView}`} initial={{
        opacity: 0,
        rotateY: currentView === 'back' ? -90 : 90
      }} animate={{
        opacity: 1,
        rotateY: 0
      }} exit={{
        opacity: 0,
        rotateY: currentView === 'back' ? 90 : -90
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} className="relative" style={{
        transformStyle: 'preserve-3d'
      }} data-id="element-99">
          <img ref={garmentRef} src={imageUrl} alt={`${colorName} ${productName} - ${currentView}`} className="max-w-full max-h-[70vh] w-auto h-auto object-contain drop-shadow-2xl" data-id="element-100" />
          {designs.sort((a, b) => a.zIndex - b.zIndex).map(design => <DraggableDesign key={design.id} designId={design.id} imageUrl={design.image} scale={design.scale} initialX={design.x} initialY={design.y} isSelected={selectedDesignId === design.id} onSelect={onDesignSelect} onPositionChange={(x, y) => onDesignPositionChange(design.id, x, y)} zIndex={design.zIndex} garmentBounds={garmentBounds} data-id="element-101" />)}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="absolute -bottom-12 left-1/2 -translate-x-1/2 text-center" data-id="element-102">
            <p className="text-sm text-gray-500" data-id="element-103">
              {colorName} {productName} -{' '}
              {currentView === 'front' ? 'Front' : 'Back'}
            </p>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </div>;
}